package one.healthium.log_symptoms.ui

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.SymptomInfoModel
import one.healthium.domain.user.models.SymptomKind
import one.healthium.domain.user.models.SymptomModel
import one.healthium.domain.user.models.SymptomSeverity
import one.healthium.domain.user.models.SymptomsLogOptions
import one.healthium.ui.common.vm.BaseViewModel

internal class LogSymptomsViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(LogSymptomsUiState())
    val state = _state.asStateFlow()

    init {
        _state.update { state ->
            state.copy(
                symptomInfoModels = SymptomKind.entries
                    .filter { it != SymptomKind.Unknown }
                    .map { kind ->
                        SymptomInfoModel(
                            kind = kind,
                            severities = SymptomSeverity.entries,
                        )
                    }
            )
        }
        userInteractor.observeUser()
            .onEach { user ->
                _state.update { state ->
                    state.copy(todaySymptomsLog = user.todaySymptomsLog)
                }
            }
            .launch()
    }

    fun onSymptomSeverityClicked(symptom: SymptomUiModel, severity: SymptomSeverity) {
        _state.update { state ->
            state.copy(
                userSelectedSymptoms = state.userSelectedSymptoms + (symptom.kind to severity)
            )
        }
    }

    fun onSaveClicked(taskId: String?, state: LogSymptomsUiState) {
        launchGlobal {
            try {
                val options = SymptomsLogOptions(
                    symptoms = state.selectedSymptoms.map { (kind, severity) ->
                        SymptomModel(kind, severity)
                    }.toList()
                )
                userInteractor.addSymptoms(options, taskId)
            } catch (e: Exception) {
                Logger.e("unable to save symptoms", e)
            }
        }
    }
}